import { Component, OnInit, Input } from "@angular/core";
import { AlertService, CommonService, InsuranceService } from "src/app/services";
import { StorageService } from "src/app/services/storage.service";
import { RxUtils } from "src/app/utils";
import { FormatsUtil } from "src/app/utils/formats.util";
import { CommonUtil } from 'src/app/utils';
import { environment } from "src/environments/environment";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { MsgConfig } from "src/app/app.messages";

@Component({
    selector: "app-tr-rx-header-info",
    templateUrl: "./tr-rx-header-info.component.html",
    styles: [],
    standalone: false
})
export class TrRxHeaderInfoComponent implements OnInit {
    @Input() transmResp: any;
    @Input() transmissionType: any;
    @Input() rxInfo: any;
    BIN = "";
    PCN = "";
    isIvrEnabled = environment.isIvrEnabled;
    unsubscribe$ : Subject<void> = new Subject();

    constructor(private _comnSvc: CommonService, private _rxUtils: RxUtils, public _formatsUtil:FormatsUtil, private _comnUtil: CommonUtil, private _alerSer: AlertService, private _storageService: StorageService, private _insuSvc: InsuranceService) {}

    ngOnInit() {
        this.getPatchBinAndPCN();
        this.isIvrEnabled = environment.isIvrEnabled && this._storageService.get("IvrGUIDDetails") ? true : false;
    }

    getPatchBinAndPCN() {
        if (this.transmResp && this.transmResp.ClaimProcess &&
            this.transmResp.ClaimProcess.objPatient && this.transmResp.ClaimProcess.objPatient.objBillToIns) {
            this.BIN = this.transmResp.ClaimProcess.objPatient.objBillToIns.BIN_NO;
            this.PCN = this.transmResp.ClaimProcess.objPatient.objBillToIns.MAG_CODE;
        }
    }

    async clickToCallOutBond(mobile,from) {
        let resp;
        let Insu = await this._rxUtils.getfindAndInsuDet(
            this.rxInfo["Patient"],
            this.transmResp.transmissionDetails.InsType,
            null,
            this._insuSvc._insuSettings$?.value?.InsuPlan?.Id ?? null
        );
        let callRequest = this._comnUtil.clickToOutBondcall(mobile);
        let patientInfo = {PatientName:this.transmResp?.transmissionDetails?.PatientName, PatId:this.transmResp?.transmissionDetails?.PatId, dob:this.transmResp?.transmissionDetails?.FormattedDOB, phoneNumber:this.transmResp?.transmissionDetails?.PatPhone, gender:this.transmResp?.transmissionDetails?.Gender, addressLine1:this.transmResp?.transmissionDetails?.PatientAddress, state:this.transmResp?.transmissionDetails?.PatState, city:this.transmResp?.transmissionDetails?.PatCity, zipCode:this.transmResp?.transmissionDetails?.PatZip } 
        this.transmResp.transmissionDetails['patientInfo'] = patientInfo ? { name: patientInfo?.PatientName, id: patientInfo?.PatId, dob: patientInfo?.dob, phoneNumber: patientInfo?.phoneNumber, gender: patientInfo?.gender, addressLine1: patientInfo?.addressLine1, state: patientInfo?.state, city: patientInfo?.city, zipCode: patientInfo?.zipCode } : null;
        let details = (from==='Insurance' ? {PlanCode:this.transmResp?.transmissionDetails?.InsType, Id:this.transmResp?.Insuplanid, InsuName: Insu?.Organization?.Name, patientInfo:this.transmResp.transmissionDetails['patientInfo']} : from === "Patient" ? {PatientName:this.transmResp?.transmissionDetails?.PatientName, PatId:this.transmResp?.transmissionDetails?.PatId, dob:this.transmResp?.transmissionDetails?.FormattedDOB, phoneNumber:this.transmResp?.transmissionDetails?.PatPhone, gender:this.transmResp?.transmissionDetails?.Gender, addressLine1:this.transmResp?.transmissionDetails?.PatientAddress, state:this.transmResp?.transmissionDetails?.PatState, city:this.transmResp?.transmissionDetails?.PatCity, zipCode:this.transmResp?.transmissionDetails?.PatZip } : this.transmResp?.transmissionDetails)                
        if(callRequest && mobile && this.isIvrEnabled) {
            if(callRequest?.ivrVendor === 1) {
                resp = await this._comnSvc.clickToCallOutBond(callRequest).pipe(takeUntil(this.unsubscribe$)).toPromise();
                if(resp) this._comnUtil.openCallLogPopup(mobile,details,from);
                else { this._alerSer.error(MsgConfig.IVR_Call_Error); this._comnSvc._isCallOngoing$.next(null); }
            } else if(callRequest?.ivrVendor === 2) {
                this._comnSvc.clickToCallOutBond(callRequest).pipe(takeUntil(this.unsubscribe$)).toPromise();
                this._comnUtil.openCallLogPopup(mobile,details,from);
            }
        }        
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
